import { render, staticRenderFns } from "./TeacherCourseTextAssignmentView.vue?vue&type=template&id=2129cf86&scoped=true"
import script from "./TeacherCourseTextAssignmentView.vue?vue&type=script&lang=js"
export * from "./TeacherCourseTextAssignmentView.vue?vue&type=script&lang=js"
import style0 from "./TeacherCourseTextAssignmentView.vue?vue&type=style&index=0&id=2129cf86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2129cf86",
  null
  
)

export default component.exports